<template>
  <div class="vip-detail-integral-detail">
    <el-row :gutter="20" class="margin-bottom">
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table
        :data="vipDetailIntegralDetailInfo.details"
        border
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column
          prop="detailId"
          :label="$t('vipDetailIntegralDetail.id')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="integralName"
          :label="$t('vipDetailIntegralDetail.accountName')"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="integralId"
          :label="$t('vipDetailIntegralDetail.accountId')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          :label="$t('vipDetailIntegralDetail.type')"
          align="center"
          width="100"
        >
          <template #default="{row}">
            {{ row.detailType === '2002' ? $t('vipDetailIntegralDetail.transferOut') : $t('vipDetailIntegralDetail.transferIn') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="relIntegralId"
          :label="$t('vipDetailIntegralDetail.relatedAccount')"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="amount"
          :label="$t('vipDetailIntegralDetail.points')"
          align="center"
          width="100"
        ></el-table-column>
        <el-table-column
          :label="$t('vipDetailIntegralDetail.objectType')"
          align="center"
          width="120"
        >
          <template #default="{row}">
            {{ row.objType === '7007' ? $t('vipDetailIntegralDetail.merchant') : $t('vipDetailIntegralDetail.user') }}
          </template>
        </el-table-column>
        <el-table-column
          prop="objId"
          :label="$t('vipDetailIntegralDetail.objectId')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="link"
          :label="$t('vipDetailIntegralDetail.phone')"
          align="center"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="orderId"
          :label="$t('vipDetailIntegralDetail.transactionNo')"
          align="center"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          :label="$t('vipDetailIntegralDetail.transactionTime')"
          align="center"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="remark"
          :label="$t('vipDetailIntegralDetail.remark')"
          align="center"
        ></el-table-column>
      </el-table>

      <el-pagination
        class="margin-top"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { getShopLinkIntegralDetail } from '@/api/user/vipDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'VipDetailIntegralDetail',
  data() {
    return {
      vipDetailIntegralDetailInfo: {
        details: [],
        link: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(this.shopId)
  },
  methods: {
    open(data) {
      this.vipDetailIntegralDetailInfo.link = data.tel
      this.loadIntegralDetailData()
    },
    loadIntegralDetailData() {
      if (!this.vipDetailIntegralDetailInfo.link) return
      
      this.loading = true
      const params = {
        link: this.vipDetailIntegralDetailInfo.link,
        shopId: this.shopId,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getShopLinkIntegralDetail(params)
        .then(res => {
          this.vipDetailIntegralDetailInfo.details = res.data
          this.pagination.total = res.records
          this.loading = false
        })
        .catch(err => {
          console.error('获取积分明细数据失败:', err)
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadIntegralDetailData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadIntegralDetailData()
    }
  }
}
</script>

<style scoped>
.vip-detail-integral-detail {
  padding: 20px;
}
.margin-bottom {
  margin-bottom: 20px;
}
.margin-top {
  margin-top: 20px;
}
.text-right {
  text-align: right;
}
</style>